import IpubTreeItem from '../tree/src/item'

/* istanbul ignore next */
IpubTreeItem.install = function(Vue) {
  Vue.component(IpubTreeItem.name, IpubTreeItem)
}

export default IpubTreeItem
